// extracted by mini-css-extract-plugin
export default {"labeled_icon_container":"LabeledIconField_labeled_icon_container__c9PK1","label":"LabeledIconField_label__oYxqk","square20px":"LabeledIconField_square20px__GLgO6"};